import { render, staticRenderFns } from "./ArrowlessCarousel.vue?vue&type=template&id=0b7df2a4&scoped=true&"
import script from "./ArrowlessCarousel.vue?vue&type=script&lang=js&"
export * from "./ArrowlessCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ArrowlessCarousel.vue?vue&type=style&index=0&id=0b7df2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7df2a4",
  null
  
)

export default component.exports